// extracted by mini-css-extract-plugin
export default {"wrapper":"link_wrapper__DQwLq"};